import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// const firebaseConfig = {
//   apiKey: 'AIzaSyDT_-qgg52kB8Q2M9jzd398p5EZ-kXmcGQ',
//   authDomain: 'poommobile-51756.firebaseapp.com',
//   projectId: 'poommobile-51756',
//   storageBucket: 'poommobile-51756.appspot.com',
//   messagingSenderId: '229458048391',
//   appId: '1:229458048391:web:0f5d679c62293a627d4f22',
//   measurementId: 'G-0W1R5Q7XYM',
// };

const firebaseConfig = {
  apiKey: "AIzaSyBLLVg9wMokUk72U7C16_Psobyf1IFLAVE",
  authDomain: "poommobiletest.firebaseapp.com",
  projectId: "poommobiletest",
  storageBucket: "poommobiletest.appspot.com",
  messagingSenderId: "762836163448",
  appId: "1:762836163448:web:50192a7217916561cd868d",
  measurementId: "G-Z7R2NP7ZDZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default app;

// Initialize Cloud Firestore
export const db = getFirestore(app);
